import { Typography } from '@mui/material';
import { WhatWeTreatList } from '../../assessment/icon-lists';

export const WhatWeTreat = () => (
  <>
    <Typography sx={{ mb: 3 }}>
      We treat many of the most common mental health conditions, including:
    </Typography>
    <WhatWeTreatList />
  </>
);
